// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1YHkX","appWrapper":"App_appWrapper__B4jOW"};